import { useMemo } from 'react';

import { WorkloadFilterLabelValue } from '@cast/types';

import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import { useWorkloadLabelValuesQuery } from 'hooks/queries/cost';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { makeSearchBoxCriteria, Criterion } from '@cast/shared-search-ui';

const namespacesCriterion: Criterion = {
  key: 'namespaces',
};

const labelsCriterion: Criterion<WorkloadFilterLabelValue[]> = {
  key: 'labels',
};

export const useWorkloadsSearchCriteria = (): Criterion[] => {
  const { cluster } = useCluster();
  const { adjustedDateRange } = useCostReportContext();

  const { labelValues: workloadTypes } = useWorkloadLabelValuesQuery({
    label: 'workload_type',
    filter: {
      clusterIds: [cluster.id],
    },
    range: adjustedDateRange,
  });

  const { labelValues: workloadNames } = useWorkloadLabelValuesQuery({
    label: 'workload_name',
    filter: {
      clusterIds: [cluster.id],
    },
    range: adjustedDateRange,
  });

  const criteria: Criterion[] = useMemo(() => {
    return [
      ...makeSearchBoxCriteria(
        {
          title: 'Workload name:',
          key: 'workloadNames',
          allowMultiple: true,
          options: workloadNames,
        },
        {
          title: 'Workload type:',
          key: 'workloadTypes',
          allowMultiple: true,
          options: workloadTypes,
        }
      ),
      namespacesCriterion,
      labelsCriterion,
    ];
  }, [workloadNames, workloadTypes]);

  return criteria;
};
